import { createSelector } from 'reselect';

import { selectCartState } from './selectCartState';

export const selectCartItems = createSelector(
    [selectCartState],
    (cart) => cart.items,
);
